export default __webpack_public_path__ + "assets/images/bc84f38cae5b1ac125e73b487a9561d3.png";